import { Component, Input } from '@angular/core'
import { InlineEditDialogCellDirective } from '../inline-edit-dialog-cell'

@Component({
  selector: 'jml-lib-cron-cell',
  templateUrl: './cron-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class CronCellComponent extends InlineEditDialogCellDirective {
  @Input() header: string

  triggerEdit(editorType: string, readOnly: boolean) {
    this.openEditorDialog(editorType, readOnly)
  }
}
